declare const window: Window &
  typeof globalThis & {
    ["useronboardingchannel"]: any;
  };

const getDeviceType = (): "android" | "ios" | "desktop" => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/android/.test(userAgent)) {
    return "android";
  }

  if (/iphone|ipad|ipod/.test(userAgent)) {
    return "ios";
  }

  return "desktop";
};

export const openAppHandler = () => {
  const deviceType = getDeviceType();
  let openLink: string;

  switch (deviceType) {
    case "android":
      openLink = "market://details?id=news.marketfeed.marketfeed";
      // Fallback to Play Store web version if market:// doesn't work
      try {
        window.open(openLink, "_blank");
        return;
      } catch (error) {
        openLink =
          "https://play.google.com/store/apps/details?id=news.marketfeed.marketfeed";
      }
      break;
    case "ios":
      openLink = "https://apps.apple.com/us/app/marketfeed/id1563184487";
      break;
    default:
      // Fallback for desktop or unknown devices
      openLink = "https://marketfeed.com";
      break;
  }

  window.open(openLink, "_blank");
};
